import api from "./api.js";

export const getUser = async () => {
  try {
    const response = await api.get("/users/my-profile");
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "failed to get use data. Please try again.";
    console.error("get user failed:", errMsg);
    throw new Error(errMsg); // علشان يظهر في واجهة المستخدم
  }
};

export const RegisterUserActivity = async (activityId) => {
  try {
    const response = await api.post(
      `/users/register-in-activity/${activityId}`,
    );
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "failed to register user activity. Please try again.";
    console.error("register user activity failed:", errMsg);
    throw new Error(errMsg);
  }
};

// export const apiUploadImage = async (file) => {
//   try {
//     const formData = new FormData();
//     formData.append("profileImage", file);
//     const response = await api.patch("/users/profile-image", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     const errMsg =
//       error.response?.data?.message ||
//       error.message ||
//       "failed to upload image. Please try again.";
//     console.error("upload image failed:", errMsg);
//     throw new Error(errMsg);
//   }
// };

export const apiUploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("profileImage", file);

    const response = await api.patch("/users/profile-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    // 1. رسالة افتراضية لو السيرفر واقع خالص
    let errMsg = "فشل في رفع الصورة، يرجى المحاولة مرة أخرى.";

    // 2. بنتشيك لو الباك إند باعت تفاصيل الفاليديشن جوه errors
    if (error.response?.data?.errors) {
      const validationErrors = error.response.data.errors;
      const firstErrorKey = Object.keys(validationErrors)[0];

      if (firstErrorKey && validationErrors[firstErrorKey].length > 0) {
        // لو لقى تفاصيل، هياخد الرسالة العربي اللي إنت كاتبها في Joi
        errMsg = validationErrors[firstErrorKey][0];
      }
    }
    // 3. لو مفيش errors بس في message عامة من الباك إند
    else if (error.response?.data?.message) {
      errMsg = error.response.data.message;
    }
    // 4. لو خطأ في النت أو الريكويست نفسه
    else if (error.message) {
      errMsg = error.message;
    }

    console.error("upload image failed:", errMsg);

    // بنرمي الإيرور بالرسالة الدقيقة عشان الـ Component اللي بتنادي الدالة دي تعرضه لليوزر
    throw new Error(errMsg);
  }
};

export const apiDeleteImage = async () => {
  try {
    const response = await api.delete("/users/delete-profile-image");
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to delete image. Please try again.";

    console.error("delete image failed:", errMsg);
    throw new Error(errMsg);
  }
};

// export const MyActivitiesAPI = async () => {
//   try {
//     const response = await api.get("/users/my-activities");
//     console.log("Data: ", response?.data.data.activities);
//     return {
//       activities: response.data.data.activities,
//       message: response?.data.message,
//     };
//   } catch (error) {
//     const errMsg =
//       error.response?.data?.message ||
//       error.message ||
//       "Failed to fetch my activities. Please try again.";
//     console.error("fetch my activities failed:", errMsg);
//     throw new Error(errMsg);
//   }
// };

export const AllActivitiesAPI = async (
  page = 1,
  limit = 5,
  statusFilter = "ACTIVE",
) => {
  try {
    // إرسال الصفحة وعدد الأنشطة لكل صفحة مع الفلتر
    const response = await api.get("/users/all-activities", {
      params: { page, limit, statusFilter }, // إضافة `statusFilter` للـ query parameters
    });

    return {
      activities: response?.data.data.activities,
      totalCount: response?.data.data.count, // العدد الكلي للأنشطة
      statusCount: response?.data?.data?.statusCount,
      message: response?.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch my activities. Please try again.";
    console.error("fetch my activities failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const MyActivitiesAPI = async (
  page = 1,
  limit = 5,
  statusFilter = "ACTIVE",
) => {
  try {
    // إرسال الصفحة وعدد الأنشطة لكل صفحة مع الفلتر
    const response = await api.get("/users/my-activities", {
      params: { page, limit, statusFilter }, // إضافة `statusFilter` للـ query parameters
    });

    return {
      activities: response.data.data.activities,
      totalCount: response.data.data.count, // العدد الكلي للأنشطة
      statusCount: response?.data?.data?.statusCount,
      message: response?.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch my activities. Please try again.";
    console.error("fetch my activities failed:", errMsg);
    throw new Error(errMsg);
  }
};

// export const participantsAPI = async (id) => {
//   try {
//     const response = await api.get(`/users/participants/${id}`);
//     return {
//       participants: response.data.data.participants,
//       message: response.data.message,
//     };
//   } catch (error) {
//     const errMsg =
//       error.response?.data?.message ||
//       error.message ||
//       "Failed to fetch participants. Please try again.";
//     console.error("fetch participants failed:", errMsg);
//     throw new Error(errMsg);
//   }
// };

// export const allUsersAPI = async () => {
//   try {
//     const response = await api.get("/users/all-users");
//     console.log("Data: ", response.data.data.users);
//     return {
//       users: response.data.data.users,
//       message: response.data.message,
//     };
//   } catch (error) {
//     const errMsg =
//       error.response?.data?.message ||
//       error.message ||
//       "Failed to fetch all users. Please try again.";
//     console.error("fetch all users failed:", errMsg);
//     throw new Error(errMsg);
//   }
// };

// promoteUserAPI, demoteUserAPI, blockUserAPI, unblockUserAPI

// services/userService.js

export const participantsAPI = async (id) => {
  try {
    const response = await api.get(`/users/participants/${id}`);

    // التعديل هنا: بنرجع الداتا اللي جاية من الباك إند بالضبط
    return {
      participants: response.data.data.participants,
      activityInfo: response.data.data.activityInfo,
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch participants. Please try again.";
    console.error("fetch participants failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const allUsersAPI = async (params) => {
  // params example: { page: 1, search: 'ahmed', role: 'student' ... }
  const queryString = new URLSearchParams(params).toString();
  const { data } = await api.get(`/users/all-users?${queryString}`); // ظبط الروت بتاعك
  return data;
};

export const promoteUserAPI = async (userId) => {
  try {
    const response = await api.patch(`/users/promote/${userId}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to promote user?. Please try again.";
    console.error("Promote user failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const demoteUserAPI = async (userId) => {
  try {
    const response = await api.patch(`/users/demote/${userId}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to demote user?. Please try again.";
    console.error("Demote user failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const blockUserAPI = async (userId) => {
  try {
    const response = await api.patch(`/users/block/${userId}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to block user?. Please try again.";
    console.error("Block user failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const unblockUserAPI = async (userId) => {
  try {
    const response = await api.patch(`/users/unblock/${userId}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to unblock user?. Please try again.";
    console.error("Unblock user failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const activitiesRequestsAPI = async (
  type = "activities",
  page = 1,
  limit = 5,
) => {
  try {
    // هنا بنبعت الـ params مع الـ request
    const response = await api.get("/users/admin/get-all-requests", {
      params: {
        type,
        page,
        limit,
      },
    });

    // بنرجع الداتا كاملة عشان الكومبوننت ياخد منها الـ items والـ pagination
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch requests. Please try again.";
    console.error("fetch requests failed:", errMsg);
    throw new Error(errMsg);
  }
};
// جلب تفاصيل طلب معين (roles or profile)
export const getRequestDetailsAPI = async (requestId, type) => {
  try {
    const response = await api.get(`/users/request/${requestId}`, {
      params: { type }, // type is 'roles' or 'profile'
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const acceptRequestAPI = async (requestId, type) => {
  // type: 'roles' or 'profile'
  const endpoint =
    type === "roles" ? "/users/approve-role" : "/users/approve-profile";
  return await api.put(`${endpoint}/${requestId}`);
};
// دالة رفض الطلب
export const rejectRequestAPI = async (requestId, type) => {
  const endpoint =
    type === "roles" ? "/users/reject-role" : "/users/reject-profile";
  return await api.put(`${endpoint}/${requestId}`);
};

export const approveActivityAPI = async (id) => {
  try {
    const response = await api.patch(`/users/admin/approve-activity/${id}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to approve activity. Please try again.";
    console.error("Approve activity failed:", errMsg);
    throw new Error(errMsg);
  }
};
export const rejectActivityAPI = async (id) => {
  try {
    const response = await api.delete(`/users/admin/reject-activity/${id}`);
    return {
      message: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to reject activity. Please try again.";
    console.error("Reject activity failed:", errMsg);
    throw new Error(errMsg);
  }
};

export const removeParticipantAPI = async (activityId, participantId) => {
  const response = await api.post(
    `/users/remove-participant/${activityId}/${participantId}`,
  );
  return response.data;
};
export const cancelRegistrationAPI = async (activityId) => {
  const response = await api.post(`/users/cancel-registration/${activityId}`);
  return response.data;
};

export const viewUserProfileAPI = async (id) => {
  try {
    const response = await api.get(`/users/view-user-profile/${id}`);
    return {
      message: response.data.message,
      user: response.data.data.user,
      isOnline: response.data.data.isOnline, // تأكد من أن الباك إند بيرجع الحقل ده
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to get user profile. Please try again.";
    throw new Error(errMsg);
  }
};

export const adminDashoardAPI = async () => {
  try {
    const response = await api.get("/users/admin-dashboard");
    return {
      activities: response.data.activities,
      user: response.data.users,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to get dashboard. Please try again.";
    throw new Error(errMsg);
  }
};
export const getStudentDashboardAPI = async () => {
  try {
    const response = await api.get("/users/student-dashboard");
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to get dashboard. Please try again.";
    throw new Error(errMsg);
  }
};
export const getSupervisorDashboardAPI = async () => {
  try {
    const response = await api.get("/users/supervisor-dashboard");
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to get dashboard. Please try again.";
    throw new Error(errMsg);
  }
};
export const PointsHistoryAPI = async () => {
  try {
    const response = await api.get("/users/history-points");
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Unable to load points history. Please try again later.";

    throw new Error(errMsg);
  }
};
export const showPointsHistoryAPI = async (userId) => {
  try {
    if (!userId) throw new Error("User ID is required.");
    const response = await api.get(`/users/show-history-points/${userId}`);
    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Unable to load points history. Please try again later.";

    throw new Error(errMsg);
  }
};
export const evaluateAPI = async (activityId, rating, comment) => {
  try {
    if (!activityId) throw new Error("Activity ID is required.");
    if (!rating) throw new Error("Rating is required.");

    const response = await api.post("/users/evaluate", {
      activityId,
      rating,
      comment,
    });

    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Unable to submit evaluation. Please try again later.";

    throw new Error(errMsg);
  }
};

export const recordAttendanceAPI = async (attendanceOTP, activityId) => {
  try {
    const response = await api.post("/users/attendance", {
      attendanceOTP,
      activityId,
    });
    return {
      attendance: response.data.message,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to attendance. Please try again.";
    throw new Error(errMsg);
  }
};
export const Top5API = async () => {
  try {
    const response = await api.get("/users/Top5");
    return {
      Top5: response.data.Top5,
    };
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to attendance. Please try again.";
    throw new Error(errMsg);
  }
};

export const getUnreadNotificationsCount = async () => {
  try {
    const response = await api.get("/users/notifications/unread-count");
    return response.data.count;
  } catch (error) {
    console.error("Failed to fetch notification count", error);
    return 0;
  }
};

// في ملف services/api.js

export const reportProblem = async (reportData) => {
  try {
    // reportData مفروض يكون شكله كده: { subject: "...", message: "..." }
    const response = await api.post("/users/report-problem", reportData);
    return response;
  } catch (error) {
    console.error("Failed to submit report", error);
    // لازم نرمي الخطأ عشان الفورم يعرف إن في مشكلة ويظهر الـ Popup
    throw error;
  }
};

/* ================= CHAT BOT ================= */

export const chatBotApi = async (message, history) => {
  try {
    const response = await api.post("/chat/send", {
      message,
      history,
    });
    return response;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        "Failed to send message to chatbot.",
    );
  }
};
